import React from "react";
import "../assets/css/main.css";

class Footer extends React.Component {
  render() {
    return (
      <footer className="mainFooter">
        <div className="container">
          <div className="row">
            <div className="footerText col-12">
              <div className="col-6 pull-right">
                <label className="socialLabel">Join the Conversation:</label>{" "}
                &nbsp;&nbsp;&nbsp;
                <span className="social">
                  <a href="https://www.facebook.com/ConstellationEnergy">
                    <i className="fa fa-facebook" />
                  </a>
                  <a href="https://twitter.com/ConstellationEG">
                    <i className="fa fa-twitter" />
                  </a>
                  <a href="https://www.youtube.com/user/ConstellationEnergy">
                    <i className="fa fa-youtube" />
                  </a>
                  <a href="https://www.linkedin.com/company/constellation-energy">
                    <i className="fa fa-linkedin" />
                  </a>
                </span>
              </div>
              <div className="col-6 pull-left">
                <span className="copyRight">
                  © { new Date().getFullYear() }. Constellation NewEnergy, Inc. All rights reserved.
                </span>
              </div>
            </div>
            <div className="horizontalRule" />
            <div className="text fontMedium">
              <p>
                <a href="https://www.constellationenergy.com/privacy-policy.html">
                  Privacy Policy
                </a>
                &nbsp;|&nbsp;
                <a href="https://www.constellationenergy.com/terms-of-use.html">
                  Terms and Conditions
                </a>
                &nbsp;|&nbsp;
                <a href="https://www.constellation.com/energy-101/blog/blog-policy.html">
                  Blog Policy
                </a>
              </p>
            </div>
            <div className="fontSmall">
              <p className="">
              These materials are provided by either Constellation NewEnergy, Inc., Constellation NewEnergy-Gas Division, LLC, Constellation Connect, LLC or Constellation Home Products & Services, LLC (d/b/a Constellation Home in Maryland and Pennsylvania and d/b/a Constellation in Georgia and Texas), each affiliates of each other. The prices of Constellation are not regulated by any state Public Utility Commission. You do not have to buy Constellation electricity, natural gas or any other products to receive the same quality regulated service from your local utility. Brand names and product names are trademarks or service marks of their respective holders. All rights reserved. Errors and omissions excepted.              </p>
              <p>
              Electricity or Gas Supplier License/Order #s: CA 1359, CTA0032; CT 01-06, 06-07-11; DE 00-162; DC GA06-2, EA01-5; GA GM-46; IL 16-0205, 17-0330; IA G-0010; ME 2000-989; MD  IR-655, IR-311, IR-500; MA GS-030, CS-015; MI U-14867, U-13660; NE NG-0043; NH DM 17-024; NJ  GSL-0101, ESL-0016; OH 09-153G, 00-003E; OR ES4 (12-162); PA A-2016-2542899, A-125095, A-110036; RI 2379(Z1), D-96-6(E); TX 10014; VA G-26, G-51, E-11A              </p>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/common/footer.jsx